import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

declare var google: any;

@Injectable()
export class GoogleMapService {
  private mapLoaded: boolean = false;

  constructor(@Inject(DOCUMENT) private document) {}

  loadMap(): Promise<void> {
    if (!this.mapLoaded) {
      return new Promise((resolve, reject) => {
        let s = this.document.createElement('script');
        s.id = 'googleMapsScript';
        s.type = 'text/javascript';
        s.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBT4G4YJClBnPzLz8DzcXB12X570aAk6kM';
        const __resolve = resolve;
        const __this = this;
        this.document.head.append(s);
        s.onload = function () {
          __this.setMapLoaded(true);
          __resolve();
        };
      });
    } else {
      return Promise.resolve();
    }
  }

  setMapLoaded(loaded: boolean) {
    this.mapLoaded = loaded;
  }

  getMap(element: HTMLElement, params: any): Promise<any> {
    return this.loadMap().then(() => {
      return new google.maps.Map(element, params);
    });
  }
}
